// src/app/core/mainPage/prompt/prompt-examples/components/TextPromptCard.tsx
import { motion } from "motion/react";
import { Check, Copy } from "lucide-react";
import type { TextPromptCardProps } from "../types";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";

export function TextPromptCard({ example, copied, onCopy, onSelect }: TextPromptCardProps) {
  const { t } = useTranslation();

  return (
    <motion.div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(example.prompt)}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className="relative flex flex-col w-64 rounded-2xl border border-white/30 dark:border-white/30 bg-white/20 dark:bg-white/15 backdrop-blur-md shadow-md hover:shadow-lg transition-all duration-200 text-left p-3 shrink-0 cursor-pointer"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(example.prompt);
        }
      }}
    >
      {/* Верхняя часть: точка + заголовок + кнопка копирования */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className="w-2 h-2 rounded-full bg-accent mt-1 shrink-0" />
          <h4 className="text-sm font-semibold text-foreground dark:text-white line-clamp-2 leading-snug">
            {example.prompt}
          </h4>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onCopy(example.prompt, example.id);
          }}
          aria-label={t("copyPrompt")}
          className="ml-2 rounded-lg bg-white/10 dark:bg-white/10 backdrop-blur-sm border border-white/20 dark:border-white/20 p-1.5 hover:bg-white/30 dark:hover:bg-white/20 transition-colors"
        >
          {copied ? (
            <Check className="h-3.5 w-3.5 text-accent" />
          ) : (
            <Copy className="h-3.5 w-3.5 text-foreground" />
          )}
        </button>
      </div>

      {/* Превью – матовое стекло */}
      <div className="flex-1 rounded-xl bg-white/10 dark:bg-white/10 backdrop-blur-sm border border-white/10 dark:border-white/10 p-2">
        <p className="text-xs leading-5 text-foreground/80 dark:text-white/70 line-clamp-4 whitespace-pre-line">
          {example.preview}
        </p>
      </div>
    </motion.div>
  );
}